import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import { viewerDisabledProps } from "../utils/permissions";

const EmployeeFormEdit = () => {
  const { id } = useParams();
  const location = useLocation();
  const employeeFromState = location.state?.employee;

  const [kitchens, setKitchens] = useState([]);
  const [formData, setFormData] = useState([]);

  const userId = localStorage.getItem("user_id");
  const [selectedFile, setSelectedFile] = useState(null);
  const [mobileError, setMobileError] = useState("");
  const [base64Image, setBase64Image] = useState("");
  const navigate = useNavigate();
  useEffect(() => {
    // URL से date पढ़ो

    // GET Request
    const fetchEmployeeData = async () => {
      try {
        const url = `https://ims-attendanceback.indevconsultancy.in/api/register-employee?employee_name=${id}`;

        const res = await axios.get(url);
        console.log(res.data);
        if (res.data && res.data.employees && res.data.employees.length > 0) {
          const employee = res.data.employees[0]; 
          setFormData({
            kitchen_id: employee.kithchenid || "",
            employee_name: employee.emp_name || "",
            father_name: employee.father_name || "",
            gender:employee.gender || "",
            mobile: employee.emp_mobile_no || "",
            joining_date: employee.date_of_joining?.slice(0, 10) || "",
            exit_date: employee.date_of_exiting?.slice(0, 10) || "",
            address: employee.address || "",
            account_number: employee.account_no || "",
            confirm_account_number: employee.account_no || "",
            date_of_birth: employee.date_of_birth?.slice(0, 10) || "",
            ifsc_code: employee.ifsc_code || "",
            profile_image: null,
            employee_code: employee.employee_code,
            pf_no: employee.pf_no || "",
            uan_no: employee.uan_no || "",
            esic_no: employee.esic_no || "",
            location: employee.location || "",
            esic_benefits: employee.esic_benefits || "",
            epf_benefits: employee.epf_benefits || "",
            total_monthly_ctc: employee.total_monthly_ctc || "",
            bank_name: employee.bank_name || "",
          });
        }
      } catch (error) {
        console.error("Error loading employee:", error);
      }
    };
    fetchEmployeeData();
  }, [id, location.search]);
  // ✅ Kitchens List
  useEffect(() => {
    axios
      .get("https://ims-attendanceback.indevconsultancy.in/api/kitchen-list")
      .then((res) => setKitchens(res.data.kitchens))
      .catch((err) => console.error("Error loading kitchens", err));
  }, []);

  // ✅ Generic Change Handler
  const handleChange = (e) => {
    const { name, value } = e.target;

    // Mobile number length check
    if (name === "mobile" && value.length > 10) return;

    setFormData({ ...formData, [name]: value });
    if (name === "mobile") {
      setMobileError(value.length < 10 ? "Enter 10 digits" : "");
    }
  };

  // ✅ File Change
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setSelectedFile(file);
    const reader = new FileReader();
    reader.onloadend = () => {
      setBase64Image(reader.result);
      console.log("Base64 Image:", reader.result);
    };
    reader.readAsDataURL(file);
  };

  // ✅ Reset Button
  const handleReset = () => {
    setFormData({
      empdetailsid:id,
      kitchen_id: employeeFromState?.kithchenid || "",
      employee_name: employeeFromState?.emp_name || "",
      father_name: employeeFromState?.father_name || "",
      gender: employeeFromState?.gender || "",
      mobile: employeeFromState?.emp_mobile_no || "",
      joining_date: employeeFromState?.date_of_joining?.slice(0, 10) || "",
      exit_date: employeeFromState?.date_of_exiting?.slice(0, 10) || "",
      account_number: employeeFromState?.account_no || "",
      confirm_account_number: employeeFromState?.account_no || "",
      address: employeeFromState?.address || "",
      profile_image: null,
      date_of_birth: employeeFromState?.date_of_birth?.slice(0, 10) || "",
      ifsc_code: employeeFromState?.ifsc_code || "",
    });
    setBase64Image("");
    setSelectedFile(null);
  };

  // ✅ Submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    const body = {
      ...formData,
      mobile: formData.mobile.trim(),
      joining_date: formData.joining_date || null,
      exit_date: formData.exit_date || null,
      gender: formData.gender || null,
      added_by_userid_id: userId,
      profile_image: base64Image,
      empdetailsid:id,
    };
    try {
      const res = await axios.put(
        "https://ims-attendanceback.indevconsultancy.in/api/register-employee",
        body
      );
      if (res.data.status) {
        Swal.fire("Success!", res.data.message, "success").then(() => {
          navigate("/employeeList");
        });
      } else {
        Swal.fire(
          "Error!",
          res.data.message || "Something went wrong",
          "error"
        );
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      Swal.fire("Error!", "Failed to submit the form", "error");
    }
  };

  return (
    <div className="bg-cream min-vh-100 py-2">
      <div className="container my-4">
        <div className="card shadow-lg">
          <div className="card-header bg-skyBlue text-white">
            <h5 className="mb-0">Edit Employee</h5>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              {/* Kitchen Dropdown */}
              <div className="mb-4">
                <label htmlFor="kitchen_id" className="form-label fw-semibold">
                  Kitchen <span className="text-danger">*</span>
                </label>
                <select
                  className="form-select"
                  id="kitchen_id"
                  name="kitchen_id"
                  value={formData.kitchen_id}
                  onChange={handleChange}
                  required
                >
                  <option value="">-- Select Kitchen --</option>
                  {kitchens.map((kitchen) => (
                    <option
                      key={kitchen.kitchenid}
                      value={String(kitchen.kitchenid)}
                    >
                      {kitchen.kitchen_name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="row g-3">
                <div className="col-md-6">
                  <label className="form-label">Employee Code</label>
                  <input
                    type="text"
                    className="form-control"
                    name="employee_code"
                    // placeholder="Enter Employee Code"
                    value={formData.employee_code}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">Employee Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="employee_name"
                    value={formData.employee_name}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">Father's / Husband's Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="father_name"
                    value={formData.father_name}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">Mobile Number</label>
                  <input
                    type="tel"
                    className="form-control"
                    name="mobile"
                    value={formData.mobile}
                    onChange={handleChange}
                    placeholder="10-digit mobile number"
                  />
                  {mobileError && (
                    <span className="text-danger">{mobileError}</span>
                  )}
                </div>

                <div className="col-md-3">
                  <label className="form-label">Date of Joining</label>
                  <input
                    type="date"
                    className="form-control"
                    name="joining_date"
                    value={formData.joining_date}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-3">
                  <label className="form-label">Date of Exit</label>
                  <input
                    type="date"
                    className="form-control"
                    name="exit_date"
                    value={formData.exit_date}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-3">
                  <label className="form-label">Gender</label>
                  <input
                    type="text"
                    className="form-control"
                    name="gender"
                    value={formData.gender}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-3">
                  <label className="form-label">Date of Birth</label>
                  <input
                    type="date"
                    className="form-control"
                    name="date_of_birth"
                    value={formData.date_of_birth}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">PF No</label>
                  <input
                    type="text"
                    className="form-control"
                    name="pf_no"
                    value={formData.pf_no}
                    onChange={handleChange}
                    placeholder="Enter PF Number"
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">UAN No</label>
                  <input
                    type="text"
                    className="form-control"
                    name="uan_no"
                    value={formData.uan_no}
                    onChange={handleChange}
                    placeholder="Enter UAN Number"
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">ESIC No</label>
                  <input
                    type="text"
                    className="form-control"
                    name="esic_no"
                    value={formData.esic_no}
                    onChange={handleChange}
                    placeholder="Enter ESIC Number"
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Location</label>
                  <input
                    type="text"
                    className="form-control"
                    name="location"
                    value={formData.location}
                    onChange={handleChange}
                    placeholder="Enter Location"
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">ESIC Benefits</label>
                  <select
                    className="form-select"
                    name="esic_benefits"
                    value={formData.esic_benefits}
                    onChange={handleChange}
                  >
                    <option value="">-- Select --</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select> 
                </div>

                <div className="col-md-6">
                  <label className="form-label">EPF Benefits</label>
                  <select
                    className="form-select"
                    name="epf_benefits"
                    value={formData.epf_benefits}
                    onChange={handleChange}
                  >
                    <option value="">-- Select --</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>

                <div className="col-md-6">
                  <label className="form-label">Total Monthly CTC (A)</label>
                  <input
                    type="number"
                    className="form-control"
                    name="total_monthly_ctc"
                    value={formData.total_monthly_ctc}
                    onChange={handleChange}
                    placeholder="Enter Total Monthly CTC"
                    step="0.01"
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">Bank Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="bank_name"
                    value={formData.bank_name || ""}
                    onChange={handleChange}
                    // placeholder="Enter bank name"
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">IFSC Code</label>
                  <input
                    type="text"
                    className="form-control"
                    name="ifsc_code"
                    value={formData.ifsc_code}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">Account Number</label>
                  <input
                    type="text"
                    className="form-control"
                    name="account_number"
                    value={formData.account_number}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">Confirm Account Number</label>
                  <input
                    type="password"
                    className="form-control"
                    name="confirm_account_number"
                    value={formData.confirm_account_number}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">Address</label>
                  <input
                    type="text"
                    className="form-control"
                    name="address"
                    value={formData.address}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">Profile Image</label>
                  <input
                    type="file"
                    className="form-control"
                    name="profile_image"
                    onChange={handleFileChange}
                  />
                </div>
              </div>

              <div className="d-flex justify-content-end gap-2 mt-4">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleReset}
                >
                  Reset
                </button>
                <button type="submit" className="btn btn-primary" {...viewerDisabledProps()}>
                  Save Employee
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmployeeFormEdit;
